import React from "react";

// Small, playful decorative shapes used sparingly around sections.
// Purely decorative — hidden from assistive tech.

export function Blob({ className = "", color = "#FFD966" }) {
  return (
    <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
      <path
        fill={color}
        d="M45,-58C58,-49,68,-35,72,-19C76,-3,74,15,66,30C58,45,44,57,28,64C11,71,-8,73,-26,67C-44,61,-61,47,-69,29C-77,11,-76,-11,-68,-29C-60,-47,-45,-61,-28,-68C-11,-75,8,-75,25,-70C42,-65,32,-67,45,-58Z"
        transform="translate(100 100)"
      />
    </svg>
  );
}

export function Star({ className = "", color = "#6554E8" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        fill={color}
        d="M12 0c.6 5.9 5.5 10.8 11.4 11.4C17.5 12 12.6 16.9 12 22.8 11.4 16.9 6.5 12 .6 11.4 6.5 10.8 11.4 5.9 12 0Z"
      />
    </svg>
  );
}

export function Squiggle({ className = "", color = "#F58B72" }) {
  return (
    <svg viewBox="0 0 120 24" className={className} aria-hidden="true" fill="none">
      <path
        d="M2 12c8-12 18 12 28 0S52 0 62 12s20 12 28 0 8-12 28 0"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Dots({ className = "", color = "#211A4D" }) {
  return (
    <svg viewBox="0 0 60 60" className={className} aria-hidden="true">
      {[6, 20, 34, 48].map((y) =>
        [6, 20, 34, 48].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="3" fill={color} />)
      )}
    </svg>
  );
}
